var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrevStep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4441 5C13.5863 5 13.7286 5.04632 13.8372 5.13897C14.0543 5.32426 14.0543 5.62471 13.8372 5.80987L8.34208 10.4999L13.837 15.1901C14.0541 15.3753 14.0541 15.6759 13.837 15.861C13.6199 16.0463 13.2681 16.0463 13.051 15.861L7.1628 10.8353C7.05856 10.7463 7 10.6256 7 10.4998C7 10.374 7.05856 10.2533 7.1628 10.1643L13.051 5.13884C13.1595 5.04632 13.3019 5 13.4441 5Z",
    fill: "#777E90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevStep);
export default __webpack_public_path__ + "static/media/prev-step.90b71165.svg";
export { ForwardRef as ReactComponent };